/* utils/datetime.js */
import { DateTime } from "luxon";

export const defaultTimezone =
  Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";

/** ISO string → DateTime in venue TZ (or null when invalid) */
export const toBusinessTZ = (iso, tz = defaultTimezone) => {
  if (!iso) return null;
  const dt = DateTime.fromISO(iso, { zone: tz });
  return dt.isValid ? dt : null;
};

/**
 * "HH:mm" → full ISO string in the given TZ.
 * If `baseDate` is falsy we use today’s date in that TZ, avoiding the
 * left-to-right default-parameter pitfall.
 */
export const timeStrToISO = (hhmm, baseDate, tz = defaultTimezone) => {
  const datePart =
    baseDate ||
    DateTime.local().setZone(tz).toISODate(); // e.g. "2025-07-14"

  return DateTime.fromISO(`${datePart}T${hhmm}`, { zone: tz }).toISO();
};

/** ISO → "HH:mm" (empty string when invalid) */
export const fmtHHMM = (dt) => (dt && dt.isValid ? dt.toFormat("HH:mm") : "");

/** Detect overnight range 22:00–02:00 */
export const isOvernight = (startISO, endISO) =>
  DateTime.fromISO(endISO)
    .diff(DateTime.fromISO(startISO))
    .as("hours") < 0;


// ✅ Safe parse in local time (not UTC)
export const fromISODate = (iso) => {
  if (!iso) return null;
  const [y, m, d] = iso.split('-').map(Number);
  return new Date(y, m - 1, d); // Local midnight, no TZ shift
};

// ✅ Safe stringify from local Date
export const toISODate = (d) => {
  if (!d) return '';
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};
// Converts "HH:MM" → "0000-01-01THH:MM:00Z"
export const timeStrToISO_abstract = (hhmm) => {
  if (!hhmm) return null;
  const [h, m] = hhmm.split(":").map(Number);
  return `0000-01-01T${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:00Z`;
};

// Converts "0000-01-01THH:MM:00Z" → "HH:MM"
export const isoToHHMM_abstract = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  const h = d.getUTCHours();  // use UTC to avoid shifting
  const m = d.getUTCMinutes();
  return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
};
